import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import React from 'react';
import { IAttachment } from '.';
import DocumentPill from './DocumentPill';

export default function DocumentPillsList({
  attachments,
  attachmentQueryStatus,
  onDelete,
  className = '',
}: {
  attachments: IAttachment[];
  attachmentQueryStatus: (attachment: IAttachment) => QueryStatus;
  onDelete: (attachment: IAttachment) => void;
  className: string;
}) {
  return (
    <>
      <div className="max-h-24 overflow-y-auto mr-2 flex-1">
        <div
          className={`flex-1 flex text-xs  gap-x-1  items-center pl-3 gap-y-1 py-2 flex-wrap`}
        >
          {attachments.map((attachment) => (
            <DocumentPill
              key={attachment.id}
              state={attachmentQueryStatus(attachment)}
              attachment={attachment}
              onDelete={() => onDelete(attachment)}
            />
          ))}
        </div>
      </div>
    </>
  );
}
